import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import useTracking from '@clearscore/hooks.use-tracking';

const useScoreBand = () => useSelector((state) => state.dashboard?.data?.creditReportInfo?.scoreBand);

const useWebappTracking = () => {
    const track = useTracking();
    const scoreBand = useScoreBand();

    const webappTrack = useCallback(
        ({ name, props = {}, onComplete } = {}) =>
            track({
                name,
                props: {
                    score_band: scoreBand,
                    ...props,
                },
                onComplete,
            }),
        [track, scoreBand],
    );

    return webappTrack;
};

export default useWebappTracking;
